import React, {useEffect, useState} from "react";
import SectionContentBox from "../SectionContentBox";
import apiService from "../../services/apiService";
import {useLanguage} from "../../hooks/LanguageContext";

const OurServices = () => {
	const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL; // Access the base URL
	const [data, setData] = useState([]);
	const { direction } = useLanguage();

	useEffect(() => {
		apiService
			.getServices()
			.then((response) => {
				setData(response.data);
			})
			.catch((err) => {
				// Handle error
			});
	}, []);

	return (
		<section
			className={`container z-0 bg-bg-darken mt-2 md:-mt-[250px] ${
				direction === "rtl" ? "" : "ltr"
			}`}
		>
			<div className="container">
				<SectionContentBox
					className="pt-[30px] text-left"
					title={direction === "rtl" ? "خدماتنا" : "Our Services"}
					hideBtn={false}
					href="/services"
					headline={
						direction === "rtl" ? (
							<>
								خدمات <span className="text-primary-700">نقل السيارات </span>
								الشاملة
							</>
						) : (
							<>
								Comprehensive <span className="text-primary-700">Car Transport </span>
								Services
							</>
						)
					}
					paragraph={
						direction === "rtl"
							? "سواء كانت سيارة واحدة أو أسطولاً كاملاً، فإننا نقدم حلول نقل مخصصة ومصممة لتناسب احتياجاتك. من الاستلام إلى التسليم، نضمن التعامل مع كل خطوة بعناية ودقة."
							: "Whether it's a single car or an entire fleet, we provide tailored transport solutions designed to meet your needs. From pick-up to delivery, we ensure every step is handled with care and precision."
					}
					buttonText={direction === "rtl" ? "المزيد" : "More"}
				/>

				<section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
					{data.map((item) => (
						<div
							className="relative w-full md:h-[594px] h-[530px]"
							key={item.id}
						>
							{/* Icon Section */}
							<div
								className={`absolute ${
									direction === "rtl" ? "left-5" : "right-5"
								} -top-10 flex items-center justify-center md:w-[136px] md:h-[140px] w-[100px] h-[100px] md:py-[35px] py-[25px] md:px-[33px] px-[23px] bg-bg-light rounded-full`}
							>
								<img
									className="max-w-[100px] max-h-[100px]"
									loading="lazy"
									src={`${baseUrl}/${item.icon}`}
									alt={`${item.title_ar} icon`}
								/>
							</div>

							{/* Card Section */}
							<div className="w-full md:h-[530px] h-[480px] overflow-hidden pt-[2px] px-[12px] pb-[30px] bg-white transition-shadow delay-200 ease-in-out hover:shadow-serviceBoxShadow rounded-[20px]">
								{/* Image */}
								<img
									className="w-full md:h-[250px] h-[230px] object-cover mb-8 rounded-lg"
									loading="lazy"
									src={`${baseUrl}/${item.image}`}
									alt={item.title_en}
								/>

								{/* Content */}
								<div className="flex flex-col items-start gap-[19px]">
									<h3 className="headline-3-ar text-grayscale-600">
										{direction === "rtl" ? item.title_ar : item.title_en}
									</h3>

									<p
										className={`w-full text-balance leading-[23.52px] font-medium ${
											direction === "rtl" ? "text-right" : "text-left"
										} text-grayscale-500`}
									>
										{direction === "rtl" ? item.description_ar : item.description_en}
									</p>

								{/*	<Button icon className="w-full md:rounded-[13px] rounded-lg">
										{direction === "rtl" ? "معرفة المزيد" : "Learn More"}
									</Button>*/}
								</div>
							</div>
						</div>
					))}
				</section>

			</div>
		</section>
	);
};

export default OurServices;
